module.exports = __webpack_public_path__ + "img/banner3优秀成果.df44a1b5.jpg";